module.exports = __webpack_public_path__ + "img/smiling.32e00f04.svg";